import { InsurancePlanName } from 'infrastructure/enums';
import { ModifiedArray } from 'infrastructure/classes/common/modified-array';

export interface IInsurancePlanNameItem {
  id: InsurancePlanName | null;
  name: InsurancePlanName;
}

type InsurancePlanNameArray = ModifiedArray<IInsurancePlanNameItem>;

export const insurancePlanNamesDataSource = (): InsurancePlanNameArray => {
  const dataSource = new ModifiedArray<IInsurancePlanNameItem>(
    {
      id: InsurancePlanName.MedicareAB,
      name: InsurancePlanName.MedicareAB,
    },
    {
      id: InsurancePlanName.UnitedHealthcare,
      name: InsurancePlanName.UnitedHealthcare,
    },
    {
      id: InsurancePlanName.Humana,
      name: InsurancePlanName.Humana,
    },
    {
      id: InsurancePlanName.CVSHealthAetna,
      name: InsurancePlanName.CVSHealthAetna,
    },
    {
      id: InsurancePlanName.AnthemBlueCrossBlueShield,
      name: InsurancePlanName.AnthemBlueCrossBlueShield,
    },
    {
      id: InsurancePlanName.KaiserPermanente,
      name: InsurancePlanName.KaiserPermanente,
    },
    {
      id: InsurancePlanName.CenteneWellCare,
      name: InsurancePlanName.CenteneWellCare,
    },
    {
      id: InsurancePlanName.Cigna,
      name: InsurancePlanName.Cigna,
    },
    {
      id: InsurancePlanName.MolinaHealthcare,
      name: InsurancePlanName.MolinaHealthcare,
    },
    {
      id: InsurancePlanName.SCANHealthPlan,
      name: InsurancePlanName.SCANHealthPlan,
    },
    {
      id: InsurancePlanName.HighmarkBlueCrossBlueShield,
      name: InsurancePlanName.HighmarkBlueCrossBlueShield,
    },
    {
      id: InsurancePlanName.UPMCHealthPlan,
      name: InsurancePlanName.UPMCHealthPlan,
    },
    {
      id: InsurancePlanName.FloridaBlue,
      name: InsurancePlanName.FloridaBlue,
    },
    {
      id: InsurancePlanName.IndependenceBlueCross,
      name: InsurancePlanName.IndependenceBlueCross,
    },
    {
      id: InsurancePlanName.HealthPartners,
      name: InsurancePlanName.HealthPartners,
    },
    {
      id: InsurancePlanName.TuftsHealthPlan,
      name: InsurancePlanName.TuftsHealthPlan,
    },
    {
      id: InsurancePlanName.Commercial,
      name: InsurancePlanName.Commercial,
    },
  );

  return dataSource;
};
